import React, { useState, useEffect } from 'react';
import ManageVendors from '../components/ShipturtleVendors/ManageVendors';
import ApproveVendors from '../components/ShipturtleVendors/ApproveVendors';
import ApproveReviews from '../components/ShipturtleVendors/ApproveReviews';
import ManageCategories from '../components/ShipturtleVendors/ManageCategories';
import styles from './ShipturtleProducts.module.css'; // ✅ reuse same CSS as Products for consistent styling
import { getCurrentUserRole } from '../services/shipturtleApi';

function ShipturtleVendors() {
  // Get initial tab from URL hash or default to 'manage-vendors'
  const getTabFromURL = () => {
    const hash = window.location.hash;
    const match = hash.match(/[?&]tab=([^&]*)/);
    return match ? match[1] : 'manage-vendors';
  };

  const [activeTab, setActiveTab] = useState(getTabFromURL());
  const [userRole, setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);

  // Listen for URL changes (browser back/forward or manual navigation)
  useEffect(() => {
    const handleHashChange = () => {
      setActiveTab(getTabFromURL());
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchRole = async () => {
      try {
        const roleData = await getCurrentUserRole();
        if (isMounted) {
          setUserRole(roleData?.role || 'vendor');
        }
      } catch (error) {
        if (isMounted) {
          setUserRole('vendor');
        }
      } finally {
        if (isMounted) {
          setRoleLoading(false);
        }
      }
    };

    fetchRole();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!roleLoading && userRole !== 'admin' && activeTab === 'approve-vendors') {
      setActiveTab('manage-vendors');
      const currentHash = window.location.hash.split('?')[0];
      window.location.hash = `${currentHash}?tab=manage-vendors`;
    }
  }, [roleLoading, userRole, activeTab]);

  const handleTabClick = (tab) => {
    if (tab === 'approve-vendors' && userRole !== 'admin') {
      return;
    }
    setActiveTab(tab);
    // Update URL hash to reflect the active tab
    const currentHash = window.location.hash.split('?')[0];
    window.location.hash = `${currentHash}?tab=${tab}`;
  };

  return (
    <div className={styles.terminalPageRoot}>
      <div className={styles.subNav}>
        <button
          className={`${styles.subNavButton} ${activeTab === 'manage-vendors' ? styles.active : ''}`}
          onClick={() => handleTabClick('manage-vendors')}
        >
          {userRole === 'admin' ? 'Manage Vendors' : 'Vendor Profile'}
        </button>
        {userRole === 'admin' && (
          <button
            className={`${styles.subNavButton} ${activeTab === 'approve-vendors' ? styles.active : ''}`}
            onClick={() => handleTabClick('approve-vendors')}
            disabled={roleLoading}
          >
            Approve Vendors
          </button>
        )}
        <button
          className={`${styles.subNavButton} ${activeTab === 'approve-reviews' ? styles.active : ''}`}
          onClick={() => handleTabClick('approve-reviews')}
        >
          Approve Reviews
        </button>
        <button
          className={`${styles.subNavButton} ${activeTab === 'manage-categories' ? styles.active : ''}`}
          onClick={() => handleTabClick('manage-categories')}
        >
          Manage Categories
        </button>
      </div>

      {/* Content area */}
      <div className={styles.content}>
        {activeTab === 'manage-vendors' && (
          <div className={styles.tabContent}>
            <ManageVendors />
          </div>
        )}

        {userRole === 'admin' && activeTab === 'approve-vendors' && (
          <div className={styles.tabContent}>
            <ApproveVendors />
          </div>
        )}

        {activeTab === 'approve-reviews' && (
          <div className={styles.tabContent}>
            <ApproveReviews />
          </div>
        )}

        {activeTab === 'manage-categories' && (
          <div className={styles.tabContent}>
            <ManageCategories />
          </div>
        )}
      </div>
    </div>
  );
}

export default ShipturtleVendors;
